import PropTypes from 'prop-types'

const propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
}

export default propTypes
